import { ArrowUpRight, Bookmark, Check } from 'lucide-react';
import { Link } from 'react-router-dom';
import type { Recommendation } from '../domain/recommendation/engine';
import { useApp } from '../app/AppContext';
import { analytics } from '../services/analytics';
import { ProductPlaceholder } from './ProductPlaceholder';

export function RecommendationCard({ recommendation, index }: { recommendation: Recommendation; index: number }) {
  const { profile, toggleSaved } = useApp();
  const { fragrance } = recommendation;
  const saved = profile.savedIds.includes(fragrance.fragrance_id);
  return (
    <article className={`recommendation-card recommendation-${index + 1}`} data-testid="recommendation-card">
      <ProductPlaceholder fragrance={fragrance} />
      <div className="recommendation-copy">
        <span className="role-tag">{String(index + 1).padStart(2, '0')} / {recommendation.role}</span>
        <h2>{fragrance.identity.name}</h2>
        <p className="brand">{fragrance.identity.brand}</p>
        <p>{recommendation.why}</p>
        <p className="sourced-fact"><strong>Sourced record</strong>{recommendation.supportingFact}</p>
        <p className="drawback"><strong>Keep in mind</strong>{recommendation.drawback}</p>
        <details className="technical-details">
          <summary>Matching detail</summary>
          <ul>
            {recommendation.score.reasons.slice(0, 4).map((reason) => <li key={reason}>{reason}</li>)}
          </ul>
          <small>{recommendation.copySource === 'ai' ? 'Batch editorial copy' : 'Deterministic editorial copy'} · product selection remains deterministic</small>
        </details>
        <div className="card-actions">
          <Link className="button button-primary" to={`/fragrance/${fragrance.fragrance_id}`}>
            View details <ArrowUpRight size={16} />
          </Link>
          <button
            className="button button-icon-text"
            type="button"
            aria-pressed={saved}
            onClick={() => {
              toggleSaved(fragrance.fragrance_id);
              analytics.track('fragrance_saved', { fragranceId: fragrance.fragrance_id });
            }}
          >
            {saved ? <Check size={16} /> : <Bookmark size={16} />} {saved ? 'Saved' : 'Save'}
          </button>
        </div>
      </div>
    </article>
  );
}
